/**
 * @flow
 */

import {
  ON_YOUR_ORDER_SUCCESS,
  YOUR_ORDER_CANCEL_ORDER_SUCCESS
} from '../your-order/actions';

const initialState = {
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_YOUR_ORDER_SUCCESS:
      return Object.assign({}, state, action.payload);

    case YOUR_ORDER_CANCEL_ORDER_SUCCESS:
      const updatedTicket = state.ticket;
      updatedTicket.state = 'cancelled';

      const newState = Object.assign({}, state, {
        ticket: updatedTicket
      });

      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/your-order/reducer.js